import { FEATURES } from '/src/features/_global/constants';

export const ACCOUNT_PERMISSIONS = {
  [FEATURES.BILLING]: ({ capabilities }) => ({
    navigate: capabilities?.billing.permissions.nav,
    edit: capabilities?.billing.permissions.edit,
    navStatus: capabilities?.billing.permissions.navStatus,
    cancel: capabilities?.billing.permissions.cancel,
    changePlan: capabilities?.billing.permissions.changePlan,
  }),
  [FEATURES.CRAZY_EGG_EMAILS]: ({ capabilities }) => ({
    navigate: capabilities?.crazyEggEmailSettings.permissions.nav,
    edit: capabilities?.crazyEggEmailSettings.permissions.edit,
  }),
  // needed for What's new as well
  [FEATURES.ACCOUNT]: ({ capabilities }) => ({
    delete: capabilities?.account.permissions.delete,
  }),
};
